module.exports = __webpack_public_path__ + "img/ostruziny-4.3da9bcca.png";